import type { BreadcrumbPathSerializable } from "./breadcrumb.types";

const ICM_URL_FALLBACK = "https://www.incredmoney.com";

export function getSiteOrigin(): string {
    return (process.env.ICM_URL ?? ICM_URL_FALLBACK).replace(/\/+$/, "");
}

export function destinationKey(path: { route?: string; href?: string }): string | undefined {
    return path.route ?? path.href;
}

export function isExternalHref(dest: string): boolean {
    return dest.startsWith("http://") || dest.startsWith("https://");
}

export function toAbsoluteUrl(dest: string, siteOrigin: string): string {
    if (isExternalHref(dest)) return dest;
    const path = dest.startsWith("/") ? dest : `/${dest}`;
    return `${siteOrigin}${path}`;
}

export function buildBreadcrumbJsonLd(
    paths: BreadcrumbPathSerializable[],
    options: { siteOrigin: string; currentPageAbsoluteUrl?: string },
): object {
    const { siteOrigin, currentPageAbsoluteUrl } = options;

    const itemListElement = paths.map((path, index) => {
        const position = index + 1;
        const isLast = index === paths.length - 1;
        const dest = destinationKey(path);
        let item: string | undefined;
        if (dest) {
            item = toAbsoluteUrl(dest, siteOrigin);
        } else if (isLast && currentPageAbsoluteUrl) {
            item = currentPageAbsoluteUrl;
        }

        return {
            "@type": "ListItem",
            position,
            name: path.label,
            ...(item ? { item } : {}),
        };
    });

    return {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement,
    };
}
